<template>
  <div class="content__text-block">
    <h1 class="h1">För deltagare</h1>
    <p>
      Här samlas all information som är relevant för deltagare. Mer information
      kommer inom kort
    </p>
    <ul class="content__year-list">
      <!-- <li>
        <a @click="toggleContent('preraceinfo')">Pre-race info</a>
      </li>
      -->
      <li>

        <a @click="toggleContent('iframe')" href="./PM.pdf" target="iframe"
          >PM 2026</a
        >
      </li>
      <!-- <li>
        <a
          @click="toggleContent('iframe')"
          href="./Inbjudan.pdf"
          target="iframe"
          >Inbjudan 2026</a
        >
      </li> -->

      <li><a @click="toggleContent('maps')">Kartor</a></li>
      <li><a @click="toggleContent('startTimes')">Starttider</a></li>
    </ul>
    <iframe
      v-if="showIframe"
      src="./Inbjudan.pdf"
      name="iframe"
      class="content__iframe"
      frameborder="0"
    ></iframe>
    <div>
      <div v-if="showMaps">
        <div class="content__image-block">
          <!-- <div class="content__image-container">
            <h3>Tävlingsområde</h3>
            <a href="/maps/tävlingsområde.jpg" target="_blank">
              <img src="/maps/tävlingsområde.jpg"/>
            </a>
          </div> -->
          <div class="content__image-container">
            <h3>Flytt av tävlingscentrum</h3>
            <a href="/maps/FlyttTC.jpg" target="_blank">
              <img src="/maps/FlyttTC.jpg" />
            </a>
          </div>
          <div class="content__image-container">
            <h3>Tävlingscentrum</h3>
            <a href="/maps/TC2026.jpg" target="_blank">
              <img src="/maps/TC2026.jpg" />
            </a>
          </div>
          <!-- <div class="content__image-container">
            <h3>Växlingsområde</h3>
            <a href="/maps/växlingsområde.jpg" target="_blank">
              <img src="/maps/växlingsområde.jpg" />
            </a>
          </div>
          -->
          <div class="content__image-container">
            <h3>Växling & Simning</h3>
            <a href="/maps/vxlsim2026.jpg" target="_blank">
              <img src="/maps/vxlsim2026.jpg" />
            </a>
          </div>
          <div class="content__image-container">
            <h3>Cykel</h3>
            <a href="/maps/Cykel2026.jpg" target="_blank">
              <img src="/maps/Cykel2026.jpg" />
            </a>
          </div>
          <!--
          <div class="content__image-container">
            <h3>Cykel, Supersprint</h3>
            <a href="/maps/cykel_supersprint.jpg" target="_blank">
              <img src="/maps/cykel_supersprint.jpg" />
            </a>
          </div>
          <div class="content__image-container">
            <h3>Cykel, barn</h3>
            <a href="/maps/cykel_barn.jpg" target="_blank">
              <img src="/maps/cykel_barn.jpg" />
            </a>
          </div> -->
          <div class="content__image-container">
            <h3>Löpning</h3>
            <a href="/maps/Lopning2026.jpg" target="_blank">
              <img src="/maps/Lopning2026.jpg" />
            </a>
          </div>
          <!--
          <div class="content__image-container">
            <h3>Löpning, sprint / motion</h3>
            <a href="/maps/löpning_sprint.jpg" target="_blank">
              <img src="/maps/löpning_sprint.jpg" />
            </a>
          </div>
          <div class="content__image-container">
            <h3>Löpning, Supersprint</h3>
            <a href="/maps/löpning_supersprint.jpg" target="_blank">
              <img src="/maps/löpning_supersprint.jpg" />
            </a>
          </div> -->
        </div>
      </div>
      <div v-if="showStartTimes">
        <div class="content__starttimes-container">
          <a href="/starttider.jpg" target="_blank">
            <img src="/starttider.jpg" alt="" />
          </a>
        </div>
      </div>
      <div class="content__pre-race-wrapper" v-if="showPreRaceInfo">
        <!-- <p>Mer info inom kort</p> -->
        <div class="content__video-container">
          <h3>SM och RM</h3>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/0Ohe0Etn3HA?si=Lh-CY5oQwyGfPtaw"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div class="content__video-container">
          <h3>Supersprint</h3>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/0sYTOZfhlDE?si=1mEuHpRHfE5Xjhf7"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  Name: "Participant",
  components: {},
  data() {
    return {
      showIframe: true,
      showMaps: false,
      showStartTimes: false,
      showPreRaceInfo: false,
    };
  },
  methods: {
    toggleContent(show) {
      if (show === "iframe") {
        this.showIframe = true;
        this.showMaps = false;
        this.showStartTimes = false;
        this.showPreRaceInfo = false;
      } else if (show === "maps") {
        this.showIframe = false;
        this.showMaps = true;
        this.showStartTimes = false;
        this.showPreRaceInfo = false;
      } else if (show === "startTimes") {
        this.showIframe = false;
        this.showMaps = false;
        this.showStartTimes = true;
        this.showPreRaceInfo = false;
      } else if (show === "preraceinfo") {
        this.showIframe = false;
        this.showMaps = false;
        this.showStartTimes = false;
        this.showPreRaceInfo = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  flex-direction: column;

  &__text-block {
    width: 80%;
    margin: auto;
    margin-bottom: 50px;
  }

  &__button-block {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  &__year-list {
    list-style: none;
    padding: 10px;
    border-bottom: 1px solid black;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    a {
      cursor: pointer;
      text-decoration: none;
      color: black;
      font-weight: bolder;
      padding: 24px;

      &:hover {
        color: rgb(66, 66, 66);
      }
    }
  }

  &__iframe {
    width: 80%;
    min-height: 700px;

    @media only screen and (max-width: 750px) {
      width: 100%;
    }
  }

  @media only screen and (max-width: 750px) {
    flex-direction: column;
  }
  &__image-block {
    display: flex;
    flex-wrap: wrap;
  }
  &__image-container {
    width: 200px;
    padding: 15px;

    img {
      width: 100%;
    }
  }

  &__starttimes-container {
    max-width: 500px;
    margin: auto;

    img {
      width: 100%;
    }
  }
  &__pre-race-wrapper {
    display: flex;
    justify-content: space-around;
    gap: 24px;
    @media only screen and (max-width: 750px) {
      flex-direction: column;
    }
  }
  &__video-container {
    width: 560px;
    height: 315px;
    @media only screen and (max-width: 750px) {
      width: 90%;
      height: auto;
    }

    iframe {
      width: 100%;
      height: 100%;
    }
  }
}

.h1 {
  font-size: 50px;
}
</style>
